export default __webpack_public_path__ + "static/oops-e6ea267398e8347f185570b4b62958be.svg";